module.exports = __webpack_public_path__ + "img/credential-logo-niice.c32c77095bba8dc7a66c940085dc2fe4.svg";